<template>
  <div class="schedule-info-attendance">
    <p>点击确认，老师将收到短信通知</p>
    <button @click="setAttdendance">确认{{ type === 4 ? "请假" : "取消请假" }}</button>
  </div>
</template>

<script>
export default {
  name: "Attendance",
  props: ["type", "st_id", "student"],
  methods: {
    async setAttdendance() {
      this.$toastLoading()
      const { code, msg } = await this.$api.schedule.ATTENDANCE({
        st_id: this.st_id,
        type: this.type,
        student_id: this.student.id
      })
      if (code === "1000") {
        this.$toastSuccess()
        this.$emit("complete")
      } else {
        this.$toastError(msg)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  width: 100%;
  padding: 10px;
  text-align: center;
  @include avenir-demi();
  color: white;
  margin: 10px 0 0 0;
  border-radius: 4px;
  background: $blue;
  border: none;
}
</style>